// extracted by mini-css-extract-plugin
export var bar1 = "navbar-module--bar1--4cb62";
export var bar2 = "navbar-module--bar2--dc8b6";
export var bar3 = "navbar-module--bar3--01387";
export var change = "navbar-module--change--d04b4";
export var dropdownMenu = "navbar-module--dropdownMenu--553c3";
export var dropdownMenuContainer = "navbar-module--dropdownMenuContainer--d7ce0";
export var dropdownMenuItem = "navbar-module--dropdownMenuItem--b0c09";
export var dropdownMenuItemContainer = "navbar-module--dropdownMenuItemContainer--06005";
export var dropdownMenuOpen = "navbar-module--dropdownMenuOpen--725d3";
export var hamburger = "navbar-module--hamburger--b6f57";
export var hideOnMobile = "navbar-module--hideOnMobile--fad9d";
export var lightBar = "navbar-module--lightBar--d0830";
export var linksContainer = "navbar-module--linksContainer--be01d";
export var mainItem = "navbar-module--mainItem--3bf79";
export var menuArrow = "navbar-module--menuArrow--c363c";
export var mobileOpen = "navbar-module--mobileOpen--8ae97";
export var moduleContainer = "navbar-module--moduleContainer--9715c";
export var navContainer = "navbar-module--navContainer--585c9";
export var profileIcon = "navbar-module--profileIcon--cfcee";
export var scrolledBar = "navbar-module--scrolledBar--7ecaf";